function CartAdd() {

}


CartAdd.prototype.listenCartAddEvent = function () {
    var SubmitBtn = $('.add-cart-btn');
    SubmitBtn.click(function (event) {
        // 阻止一些默认行为，比如这个按钮是在form 表单里提交，默认情况下是会执行form表单提交的
        event.preventDefault();
        var local_this = $(this);
        var sku_id = local_this.attr('data-sku-id');
        if(sku_id === ''){
            swal({
                title: "info", text: "Pls choose Spec for the goods ", type: "info",
                showCancelButton: false, showConfirmButton: true, buttons: false, timer: 3000,
            });
            return;
        }
        // for checking if button is in product-detail
        var button_type = local_this.attr('data-button-type');
        var count;
        //tag-a: mean this button is for product-detail or quick-view of ProductList. else: belong to sku in index page or sku in 'You Might Also Like'
        if (button_type === 'tag-a') {
            count = $('.count-show').val();
            count = parseInt(count);
            if (count < 1) {
                count = 1;
            } else if (count >10) {
                count = 10;
            }
            //  disable button 防止用户重复提交
            local_this.css("pointer-events", "none")
            local_this.text('Adding...');
        } else {
            count = 1;
            //  disable button 防止用户重复提交
            local_this.attr("disabled", true);
            local_this.text('submitting');
        }

        ajaxTool.post({
            'url': '/cart/cart_add/',
            'data': {
                'sku_id': sku_id,
                'count': count,
            },
            // 注意： ajax的回调函数success首先是在myajax.js里的'ajax'下面的args['success']执行的，如果
            // 'code'=200 才调用这里的'success'， 否则code'!=200的情况在那边处理 'fail':也在那边处理
            'success': function (result) {
                // alert(JSON.stringify(result));
                // 200 表示注册或登入成功。
                if (result['code'] === 200) {
                    if(result['data']['sign'] === 'login_process'){
                        // total_count: 用户购物车里有几种SKU(条目数)
                        var total_count = result['data']['total_count'];
                        // 更新页面顶部的购物车条目数
                        $(".header-action-num").text(total_count);
                        swal({
                            title: "success", text: "good job, success", type: "success",
                            showCancelButton: false, showConfirmButton: true, buttons: false, timer: 1000,
                        });

                    }else if(result['data']['sign'] === 'not_login_process'){
                        var sku_stock = result['data']['sku_stock'];
                        sku_stock = parseInt(sku_stock);
                        // data type in cookie: { 'qskyme_cart':{'1':10,'2':20,'3':30}}
                        var cart_dict_str = $.cookie('qskyme_cart');
                        // cookie没有数据就显示undefined
                        var cart_data;
                        if(!cart_dict_str){
                            //把当前的ID和数量放入字典
                            var temp_dict = {};
                            if(count > sku_stock){
                                count = sku_stock;
                            }
                            if(count > 10){
                                count = 10;
                            }
                            temp_dict[sku_id] = count;
                            // { path: "/"} 表示数据存储的作用域为网站全局，所有页面可以访问此COOKIE数据
                            $.cookie('qskyme_cart', JSON.stringify(temp_dict), { path: "/"});
                            // 前端购物车数量显示
                            $(".header-action-num").text(1);
                            cart_data = JSON.stringify(temp_dict);
                        }else{
                            // 把字符串变成对象
                            var cart_dict = JSON.parse(cart_dict_str);
                            // alert(JSON.stringify(cart_dict));
                            // 此处的COUNT是全局变量
                            var count_saved = cart_dict[sku_id];
                            if(count_saved){
                                count += parseInt(count_saved);
                            }
                            if(count > sku_stock){
                                count = sku_stock;
                            }
                            if(count > 10){
                                count = 10;
                            }
                            //如果当前字典有此KEY, 就把字典里的VALUE替换成当前值 如果当前字典没有此KEY, 就创建
                            cart_dict[sku_id] = count;
                            // 前端购物车数量显示
                            var length= Object.keys(cart_dict).length;
                            $(".header-action-num").text(length);
                            // { path: "/"} 表示数据存储的作用域为网站全局，所有页面可以访问此COOKIE数据
                            $.cookie('qskyme_cart', JSON.stringify(cart_dict), { path: "/"});
                            cart_data = JSON.stringify(cart_dict);
                        }
                        // 把购物车数据绑定到input上 ,点击时候传到后端去
                        // var cart_url = "/cart/?" + 'cart_data=' + cart_data;
                        // $('.header-action-cart-url').attr('href',cart_url);
                        $('.header-action-cart-url').find("input[name='cart_data']").val(cart_data);
                         swal({
                            title: "success", text: "good job, success", type: "success",
                            showCancelButton: false, showConfirmButton: true, buttons: false, timer: 1000,
                        });
                        // cart_dict_str = $.cookie('qskyme_cart');
                        // alert(cart_dict_str);

                    }

                } else {
                    // alert(JSON.stringify(result));
                    var messageObject = result['message'];
                    if (typeof messageObject == 'string' || messageObject.constructor === String) {
                        swal("Warning!", messageObject, "warning");
                    } else {
                        // format : {"password":['', ''], "telephone":['', '']}
                        var content = '';
                        for (var key in messageObject) {
                            var messages = messageObject[key];
                            var message = messages[0];
                            content += '<' + message + '!' + '>'
                        }
                        swal("Warning!", content, "warning");
                    }

                }
                //  恢复按钮功能
                if (button_type === 'tag-a') {
                    local_this.css("pointer-events", "auto")
                    local_this.text('Add to cart');
                } else {
                    //  恢复按钮功能
                    local_this.attr("disabled", false);
                    local_this.text('Add to cart');
                }

            }
        });
    })
}

function GetUrlRelativePath() {
　　　　var url = document.location.toString();
　　　　var arrUrl = url.split("//");
　　　　var start = arrUrl[1].indexOf("/");
       return arrUrl[1].substring(start);

　　}


CartAdd.prototype.run = function () {

    this.listenCartAddEvent();
}

$(function () {
    var cartAdd = new CartAdd();
    cartAdd.run();
})

